import { ELSDropDownOption } from '../../components/els.components';
import { QuizQuestionSelectionDto } from '../../apis/nhe-ai-chat-service/nhe-ai-chat-service.dtos';
import { SEGMENT_SIZE_ALL } from './quiz-questions.constants';

// "All questions" first, then every size from 1 to the number of matching questions
export const getSegmentSizeOptions = (totalMatches: number): ELSDropDownOption[] => [
  { name: `All questions (${totalMatches})`, value: SEGMENT_SIZE_ALL },
  ...Array.from({ length: totalMatches }, (_, index) => ({
    name: String(index + 1),
    value: String(index + 1),
  })),
];

// Consecutive windows of `segmentSize` questions, e.g. 1-10, 11-20, ... The last one is shorter when
// the total is not a multiple of the size. A segment is a position in the sorted matches.
export const getSegmentOptions = (totalMatches: number, segmentSize: number): ELSDropDownOption[] => (
  Array.from({ length: Math.ceil(totalMatches / segmentSize) }, (_, index) => {
    const start = index * segmentSize + 1;
    const end = Math.min((index + 1) * segmentSize, totalMatches);
    return {
      name: start === end ? String(start) : `${start}-${end}`,
      value: String(index),
    };
  })
);

// The 1-based inclusive window NACS should take from the sorted matches; none for "All questions".
// The end is not clamped to the match count: NACS clamps it, so a stale count can't shorten the window.
export const getSegmentWindow = (
  segmentSize: string,
  segment: string
): Pick<QuizQuestionSelectionDto, 'startIndex' | 'endIndex'> => {
  if (segmentSize === SEGMENT_SIZE_ALL) {
    return {};
  }
  const size = Number(segmentSize);
  const startIndex = Number(segment) * size + 1;
  return { startIndex, endIndex: startIndex + size - 1 };
};
